/* eslint max-len: off */
import React from 'react';
import {Icon} from '../createSvg';
import {IconProps} from '../types';

export const Update = (props: IconProps) => (
  <Icon {...props}>
    <path d="M5 1V23H19V1H5ZM17 19H7V5H17V19ZM16 13H13V8H11V13H8L12 17L16 13Z" />
  </Icon>
);
